import { Reveal } from "../landing/Reveal";

const CATS = ["Fashion", "Electronics", "Books", "Toys", "Organic"];

const PRODUCTS = [
  { emoji: "👟", name: "Campus Sneakers", price: "₹1,299", reel: "48K views" },
  { emoji: "🎧", name: "Study Headphones", price: "₹1,899", reel: "22K views" },
  { emoji: "📗", name: "DSA Crunch Book", price: "₹349", reel: "9K views" },
  { emoji: "🌿", name: "Organic Snack Box", price: "₹499", reel: "15K views" },
];

export const ShopBite = () => (
  <section id="shopbite" data-testid="shopbite-section" className="relative overflow-hidden py-20 sm:py-24">
    <div aria-hidden="true" className="absolute -left-32 top-1/4 h-[380px] w-[380px] rounded-full bg-[#22C55E]/10 blur-[130px]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#22C55E]">🛍️ ShopBite</p>
        <h2 className="mt-3 max-w-xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Watch reel → buy product → checkout. That's it.
        </h2>
      </Reveal>

      <Reveal delay={0.08}>
        <div className="no-scrollbar -mx-4 mt-8 flex gap-2.5 overflow-x-auto px-4 pb-1">
          {CATS.map((c) => (
            <button
              key={c}
              data-testid={`shop-cat-${c.toLowerCase()}`}
              className="shrink-0 rounded-full border border-white/10 bg-white/[0.04] px-5 py-2.5 text-sm font-semibold text-slate-300 backdrop-blur-xl transition-colors hover:border-[#22C55E]/60 hover:text-white"
            >
              {c}
            </button>
          ))}
        </div>
      </Reveal>

      <div className="mt-8 grid grid-cols-2 gap-4 lg:grid-cols-4">
        {PRODUCTS.map((p, i) => (
          <Reveal key={p.name} delay={0.06 * i} className="h-full">
            <div
              data-testid={`product-${p.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="group flex h-full flex-col rounded-3xl border border-white/10 bg-white/[0.04] p-5 backdrop-blur-xl transition-all duration-300 hover:-translate-y-1.5 hover:border-[#22C55E]/50"
            >
              <div className="relative flex h-28 items-center justify-center rounded-2xl bg-white/[0.04]">
                <span className="text-5xl transition-transform duration-300 group-hover:scale-125">{p.emoji}</span>
                <span className="absolute left-2 top-2 rounded-full bg-black/50 px-2 py-0.5 font-jbmono text-[9px] text-[#06B6D4]">
                  ▶ {p.reel}
                </span>
              </div>
              <p className="mt-4 text-sm font-bold text-white">{p.name}</p>
              <div className="mt-auto flex items-center justify-between pt-3">
                <span className="font-display text-lg font-extrabold text-[#22C55E]">{p.price}</span>
                <button className="rounded-full bg-white/10 px-3.5 py-1.5 text-xs font-bold text-white transition-colors group-hover:bg-[#22C55E] group-hover:text-[#09090B]">
                  + Cart
                </button>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
